import React from "react";

const Dashboard: React.FC = () => {
  return <div>TODO Dashboard</div>;
};

export default Dashboard;
